import React, { useState, useRef, useEffect } from 'react';
import LoginModal from '../auth/LoginModal';
import RegisterModal from '../auth/RegisterModal';
import ForgotPasswordModal from '../auth/ForgotPasswordModal';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import CreditBalanceDisplay from '../credits/CreditBalanceDisplay';
import Logo from './Logo';
import './Header.css';

const Header = () => {
  const { isAuthenticated, user, logout } = useAuth();
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showRegisterModal, setShowRegisterModal] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);
  const [showForgotPasswordModal, setShowForgotPasswordModal] = useState(false);

  const handleOpenLoginModal = (e) => {
    if (e) e.preventDefault();
    setShowLoginModal(true);
    setShowRegisterModal(false);
    document.body.style.overflow = 'hidden';
  };

  const handleCloseLoginModal = () => {
    setShowLoginModal(false);
    document.body.style.overflow = '';
  };

  const handleCloseRegisterModal = () => {
    setShowRegisterModal(false);
    document.body.style.overflow = '';
  };

  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  const handleSwitchToRegister = () => {
    setShowLoginModal(false);
    setShowRegisterModal(true);
    document.body.style.overflow = 'hidden';
  };

  const handleOpenForgotPasswordModal = () => {
    setShowLoginModal(false);
    setShowForgotPasswordModal(true);
    document.body.style.overflow = 'hidden';
  };

  const handleCloseForgotPasswordModal = () => {
    setShowForgotPasswordModal(false);
    document.body.style.overflow = '';
  };

  const handleBackToLogin = () => {
    setShowLoginModal(true);
    setShowRegisterModal(false);
    setShowForgotPasswordModal(false);
    document.body.style.overflow = 'hidden';
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [dropdownRef]);

  return (
    <>
      <header className="header-container">
        <div className="left-section">
          <div className="platform-logo">
            <Logo linkTo="/" />
          </div>
          <Link to="/how-it-works" className="how-it-works-button">
            How it works
          </Link>
        </div>
        <nav className="header-nav">
          {isAuthenticated ? (
            <div className="authenticated-nav" ref={dropdownRef}>
              <div className="header-credits">
                <CreditBalanceDisplay showLabel={false} size="small" />
              </div>
              <div className="auth-buttons-group">
                <button className="user-menu-button" onClick={toggleDropdown}>
                  <div className="user-avatar">
                    <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
                      <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
                    </svg>
                  </div>
                  <span className="username-display">{user.username}</span>
                  <span className="dropdown-arrow">▼</span>
                </button>
                <button onClick={logout} className="logout-button">Logout</button>
              </div>

              {showDropdown && (
                <div className="user-dropdown">
                  <div className="dropdown-header">
                    <div className="dropdown-avatar">
                      <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
                        <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
                      </svg>
                    </div>
                    <div className="dropdown-user-info">
                      <span className="dropdown-username">{user.username}</span>
                      <span className="user-type-badge">
                        {user.user_type === 'content_creator' || user.user_type === 'super_admin' ? 'Creator' : 'User'}
                      </span>
                    </div>
                  </div>
                  <div className="dropdown-menu">
                    <Link
                      to={user.user_type === 'content_creator' || user.user_type === 'super_admin' ? '/dashboard/content-creator' : '/dashboard/general-user'}
                      className="dropdown-item"
                      onClick={() => setShowDropdown(false)}
                    >
                      <span className="dropdown-item-icon">
                        <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
                          <path d="M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z"/>
                        </svg>
                      </span>
                      <span>Dashboard</span>
                    </Link>
                    <Link
                      to="/profile"
                      className="dropdown-item"
                      onClick={() => setShowDropdown(false)}
                    >
                      <span className="dropdown-item-icon">
                        <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
                          <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
                        </svg>
                      </span>
                      <span>Profile</span>
                    </Link>
                    <button onClick={logout} className="dropdown-item logout-item">
                      <span className="dropdown-item-icon">
                        <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
                          <path d="M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z"/>
                        </svg>
                      </span>
                      <span>Log out</span>
                    </button>
                  </div>
                </div>
              )}
            </div>
          ) : (
            <div className="unauthenticated-nav">
              <button onClick={handleOpenLoginModal} className="login-button">
                Login / Register
              </button>
            </div>
          )}
        </nav>
        {(showLoginModal || showRegisterModal) && <div className="modal-overlay"></div>}
        <LoginModal
          isOpen={showLoginModal}
          onClose={handleCloseLoginModal}
          onSwitchToRegister={handleSwitchToRegister}
          onForgotPassword={handleOpenForgotPasswordModal}
        />
        <RegisterModal
          isOpen={showRegisterModal}
          onClose={handleCloseRegisterModal}
          onBackToLogin={handleBackToLogin}
        />
        <ForgotPasswordModal
          isOpen={showForgotPasswordModal}
          onClose={handleCloseForgotPasswordModal}
          onBackToLogin={handleBackToLogin}
        />
      </header>
    </>
  );
};

export default Header;